import { render, staticRenderFns } from "./acc_page.vue?vue&type=template&id=593c5c53"
import script from "./acc_page.vue?vue&type=script&lang=js"
export * from "./acc_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports